import A from 'utils/metrics/analytic'

// Открыл Podcast
const A_p_openPodcast = () => {
  A.setEvent('podcast_open')
  console.log('podcast_open')
}

const A_p_playPodcast = () => {
  A.setEvent('podcast_play')
  console.log('podcast_play')
}

export { A_p_openPodcast, A_p_playPodcast }
